/**
 * 公開表示設定APIサービス
 *
 * @file public-settings.service.ts
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 認証不要の公開API GET /api/v1/public/display-settings から
 * 表示系設定（新着件数・リダイレクト秒数・代理サービス一覧等）を取得する。
 */

import { safeFetch } from '@shared/utils/api';
import type { DisplaySettings } from '@/contexts/displaySettingsSnapshot';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function getPublicDisplaySettings(): Promise<DisplaySettings> {
  return safeFetch<DisplaySettings>(
    `${API_BASE_URL}/api/v1/public/display-settings`,
    { errorMessage: '表示設定の取得に失敗しました。' }
  );
}
